import { render, staticRenderFns } from "./LastUpdated.vue?vue&type=template&id=65b02a7e&"
import script from "./LastUpdated.vue?vue&type=script&lang=js&"
export * from "./LastUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports